<template>
  <div>
    <ul
      v-if="!hasEdit"
      class="nav nav-tabs mb-3">
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          :class="{ active: type === 'manual' }"
          @click="type='manual'">
          Manual
        </button>
      </li>
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          :class="{ active: type === 'auto' }"
          @click="type='auto'">
          Automático AI <i class="fa fa-star" />
        </button>
      </li>
    </ul>

    <div v-if="type==='manual'">
      <div
        v-if="!hasEdit"
        class="mb-3">
        <SelectAvalibleScoreform
          :value="value.scoreform_id"
          @inputObject="setScoreform"
          :placeholder="$t('Select a scorecard')"
          :jobId="selectedJob._id" />
      </div>
      
      <div
        class="card mb-3"
        v-if="value.scorecard && value.scorecard.groups && value.scorecard.groups.length">
        <div
          v-for="(group, group_index) in value.scorecard.groups"
          :key="group_index">

          <div class="card-header">
            <strong>{{ group.name }}</strong>
          </div>

          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="(question, question_index) in group.questions"
              :key="question_index">

              <div class="d-flex">
                <div class="w-100 mr-2">
                  <strong>{{ question.name }}</strong>
                </div>
                <div class="">
                  <radio-evaluation
                    size="sm"
                    v-model="question.score"></radio-evaluation>
                </div>
                <div class="">
                  <button
                    type="button"
                    class="btn btn-light btn-sm disable"
                    @click="showComment(question)"
                    :disabled="Boolean(question.comment)">
                    <i class="fas fa-align-left" />
                  </button>
                </div>
              </div>
              <ValidateMessage :error="validateErrors['scorecard.groups.' + group_index + '.questions.' + question_index + '.score']" />
              
              <div
                v-if="question.show_comment || question.comment"
                class="mt-2">
                <textarea-autosize
                  v-model="question.comment"
                  :min-height="30"
                  :max-height="350"
                  class="form-control">
                  </textarea-autosize>
                <ValidateMessage :error="validateErrors['scorecard.groups.' + group_index + '.questions.' + question_index + '.comment']" />
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="mb-2">
          <div>
            <radio-evaluation
              v-model="value.score"
              :legend="true"></radio-evaluation>
          </div>
          <ValidateMessage :error="validateErrors.score" />
        </div>
        <div class="mb-2">
          <textarea-editable v-model="value.comment"></textarea-editable>
          <ValidateMessage :error="validateErrors.comment" />
        </div>
        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary"
            @click="saveEvaluation(value)">
            {{ $t('Save') }}
          </button>
          <button
            v-if="hasEdit"
            type="button"
            class="btn btn-light"
            @click="$emit('cancel')">
            {{ $t('Cancel') }}
          </button>
        </div>
      </div>
    </div>

    <div
      style="position: relative;"
      v-if="type==='auto'">
      <vue-particles
        v-if="loading"
        style="width: 100%; height: 100%; position: absolute; z-index: 2"
        color="#000000"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#212529"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="5"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push" />
      <div :class="{'box-loading': loading}">
        <p>Você pode avaliar o candidato em relação à vaga com apenas um clique. A inteligência artificial analisa de forma integrada as informações disponíveis, como o perfil do candidato e o perfil da vaga, e, quando disponíveis, a avaliação Big5, o resumo da transcrição da entrevista e o resumo da entrevista por voz gerado por IA. Isso proporciona uma avaliação completa, consistente e mais assertiva.</p>

        <div class="form-group">
          <h6 class="mb-2">Incluir:</h6>

          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="add_big5" v-model="autoEvaluationOptions.add_big5">
            <label class="custom-control-label" for="add_big5">
              Big5 (Perfil de personalidade)
            </label>
          </div>

          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="add_qca" v-model="autoEvaluationOptions.add_qca">
            <label class="custom-control-label" for="add_qca">
              QCA (Culture Assessment)
            </label>
          </div>

          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="add_intervoice" v-model="autoEvaluationOptions.add_intervoices">
            <label class="custom-control-label" for="add_intervoice">
              Pré-entrevistas por Voz (IA)
            </label>
          </div>

          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="add_transcriptions" v-model="autoEvaluationOptions.add_meetinsights">
            <label class="custom-control-label" for="add_transcriptions">
              Transcrições de entrevistas
            </label>
          </div>

          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="add_evaluations" v-model="autoEvaluationOptions.add_evaluations">
            <label class="custom-control-label" for="add_evaluations">
              Avaliações (internas)
            </label>
          </div>

          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="add_notes" v-model="autoEvaluationOptions.add_notes">
            <label class="custom-control-label" for="add_notes">
              Notas
            </label>
          </div>

        </div>

        <button
          type="button"
          class="btn btn-primary"
          @click="createAutoEvaluation()">
          {{ $t('Gerar') }}
        </button>
      </div>
    </div>

  </div>

</template>

<script>
import SelectAvalibleScoreform from '@/components/Fields/SelectAvalibleScoreform'
import RadioEvaluation from '@/components/Fields/RadioEvaluation'
import Formsave from '@/utils/Formsave'

export default {
  name: 'CandidateEvaluationForm',
  components: {
    SelectAvalibleScoreform,
    RadioEvaluation
  },
  props: {
    initValue: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      type: 'manual',
      validateErrors: false,
      loading: false,
      value: this.defaultValues(this.initValue),
      autoEvaluationOptions: {
        add_big5: true,
        add_qca: true,
        add_intervoices: true,
        add_meetinsights: true,
        add_evaluations: true,
        add_notes: true
      }
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    hasEdit () {
      return this.value._id
    }
  },
  created () {
    if (!this.hasEdit) {
      Formsave.sync(this, 'CandidateEvaluation', this.candidate._id, 'value', (data) => {
        return data.scorecard || data.comment
      })
    }
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    saveEvaluation
    */
    saveEvaluation (data) {
      if (data._id) this.updateEvaluation(data)
      else this.createEvaluation(data)
    },
    /*
    resetEvaluation
    */
    resetEvaluation () {
      this.value = {}
      this.validateErrors = false
    },
    /*
    createEvaluation
    */
    createEvaluation (data) {
      this.loading = true

      data.candidate_id = this.candidate._id
      data.job_id = this.selectedJob._id

      this.$store
      .dispatch('createEvaluation', data)
      .then((result) => {
        this.loading = false
        this.resetEvaluation()
        this.$emit('created', result.data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    createAutoEvaluation
    */
    createAutoEvaluation () {
      this.loading = true

      this.$store
      .dispatch('createAutoEvaluation', {
        candidate_id: this.candidate._id,
        job_id: this.selectedJob._id,
        options: this.autoEvaluationOptions
      })
      .then((result) => {
        this.loading = false
        this.resetEvaluation()
        this.$emit('created', result.data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateEvaluation
    */
    updateEvaluation (data) {
      this.loading = true

      this.$store
      .dispatch('updateEvaluation', data)
      .then((result) => {
        this.loading = false
        this.$emit('updated', data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    showComment (question) {
      this.$set(question, 'show_comment', !question.show_comment)
      this.$set(question, 'comment', null)
    },
    /*
    setScoreform
    */
    setScoreform (scoreform) {
      if (scoreform) {
        const scorecard = {
          name: scoreform.name,
          groups: scoreform.groups.map(group => {
            return {
              name: group.name,
              questions: group.questions.map(question => {
                return {
                  name: question,
                  comment: null,
                  score: null
                }
              })
            }
          })
        }

        this.value = {
          ...this.value,
          scoreform_id: scoreform._id,
          scorecard: scorecard
        }
      } else {
        this.value = {
          ...this.value,
          scoreform_id: null,
          scorecard: null
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Evaluation/CandidateEvaluationForm.vue